import Vue from 'vue'
import Router from 'vue-router'

// import Start from './views/start/start.vue';
import Error from './views/error/index.vue';

import Index from './views/index/index.vue';
import Seek from './views/seek/index.vue';
import Me from './views/me/index.vue';
import Song from './views/song/index.vue';
import NewSong from './views/song/newIndex.vue';
import xySong from './views/song/xyIndex.vue';
import mzSong from './views/song/mzIndex.vue';
import qySong from './views/song/qyIndex.vue';
import redSong from './views/song/redIndex.vue';
import xybj from './views/song/xybj.vue';
import hsjd from './views/song/hsjd.vue';
import ctqy from './views/song/ctqy.vue';
import mzzg from './views/song/mzzg.vue';
import Album from './views/album/index.vue';


import Login from './views/login/index.vue';
import Phonecode from './views/login/phoneCode.vue';
import Codefirm from './views/login/codeFirm.vue';

import Collect from './views/me/myCollect.vue';
import Suggest from './views/me/suggestions.vue';
import Abouts from './views/me/meAbout.vue';

import Project from './views/specials/Project.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },{
      path: '/seek',
      name: 'seek',
      component: Seek
    },{
      path: '/me',
      name: 'me',
      component: Me
    },{
      path: '/collect',
      name: 'collect',
      component: Collect
    },{
      path: '/suggest',
      name: 'suggest',
      component: Suggest
    },{
      path: '/about',
      name:'about',
      component: Abouts
    },{
      path: '/login',
      name: 'login',
      component: Login
    },{
      path: '/phonecode',
      name: 'phonecode',
      component: Phonecode
    },{
      path: '/codefirm',
      name: 'codefirm',
      component: Codefirm
    },{
      path: '/song',
      name: 'song',
      component: Song
    },{
      path: '/newSong',
      name: 'newSong',
      component: NewSong
    },{
      path: '/xySong',
      name: 'xySong',
      component: xySong
    },{
      path: '/mzSong',
      name: 'mzSong',
      component: mzSong
    },{
      path: '/qySong',
      name: 'qySong',
      component: qySong
    },
    {
      path: '/xybj',
      name: 'xybj',
      component: xybj
    },
    {
      path: '/hsjd',
      name: 'hsjd',
      component: hsjd
    },
    {
      path: '/ctqy',
      name: 'ctqy',
      component: ctqy
    },
    {
      path: '/mzzg',
      name: 'mzzg',
      component: mzzg
    },
    {
      path: '/redSong',
      name: 'redSong',
      component: redSong
    },{
      path: '/album',
      name: 'album',
      component: Album
    },{
      path: '/project',
      name: 'project',
      component: Project
    },{
      path: '/error',
      name: 'error',
      component: Error
    }
  ]
})
